import { createFileRoute, Navigate, useLocation } from "@tanstack/react-router";

import { useGetAvailableDexes } from "@/generated/api/pools/pools";

export const Route = createFileRoute("/pools/")({ component: FirstDex });

function FirstDex() {
    const first = useGetAvailableDexes().data?.available_dexes[0];
    // `Navigate` redirects only when its props object changes, and the compiler memoizes it; one
    // instance kept across visits would skip the redirect and strand the page on bare /pools.
    // Keyed by history entry, every visit gets a fresh one.
    const visit = useLocation({ select: (location) => location.state.__TSR_key });
    return first ? <Navigate key={visit} to="/pools/$dex" params={{ dex: first }} replace /> : null;
}
